import { useState } from "react";
import { useDispatch } from "react-redux";
import { addAuth } from "../store/slices/authSlice";
import { redirect, useNavigate } from "react-router-dom";



function Auth() {
    const dispatch = useDispatch()
    let navigate = useNavigate();

    const [formData, setformData] = useState({
        login: "",
        password: ""
    })
    function changeHandle(e) {
        setformData(state => ({ ...state, [e.target.name]: e.target.value }))
    }

    function submit() {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify(formData);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw
        };

        fetch("https://onza-api.ibm.kg/api/admin/auth/login", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.success) {
                    dispatch(addAuth(result))
                    localStorage.setItem("token", JSON.stringify(result))
                    navigate("/order/1")
                }
            })
            .catch((error) => console.error(error));
    }

    return (<>
        <div id="container">
            <form>
                <label for="name">Логин:</label>
                <input type="name" value={formData.login} name="login" onChange={changeHandle} />
                <label for="username">Пароль:</label>
                <p><a href="#">Забыли пароль?</a></p>
                <input type="password" value={formData.password} name="password" onChange={changeHandle} />
                <div id="lower">
                    <input type="checkbox" /><label class="check" for="checkbox">Запомнить меня</label>
                    <input type="button" value="Войти" onClick={submit} />
                </div>
            </form>
        </div>
    </>);
}

export default Auth;